'use strict';

MxRichTextBoxCtrl.$inject = [
	'$scope',
	'$element',
	'$timeout',
	'$mdUtil',
	'$ocLazyLoad',
	'mx.components.LazyLoadCfg',
	'mx.SolutionBuilderAgent.Http',
	'mx.components.TinymceUtils',
	'mx.shell.EventService',
	'mx.sb.Attachment.MxAttachmentService',
	'mx.app.DeviceService',
	'mx.shell.Config',
];
export default function MxRichTextBoxCtrl(
	$scope,
	$element,
	$timeout,
	$mdUtil,
	$ocLazyLoad,
	lazyLoadCfg,
	http,
	mxTinymceUtils,
	eventService,
	attachmentService,
	deviceService,
	mxConfig
) {
	var vm = this;
	var editorInstance,
		fixedToolbarContainer,
		useAdvancedMode,
		isMobile,
		isToolbarBottomMode = false;

	const anticache = `?anticache=${mxConfig.settings.productVersion}`;

	document.execCommand('defaultParagraphSeparator', false, 'p');

	let isFullscreen = false;
	vm.toggleFullscreen = toggleFullscreen;

	if (!$ocLazyLoad.isLoaded('ui.tinymce')) {
		$ocLazyLoad.setModuleConfig({
			name: 'ui.tinymce',
			serie: true,
			files: [
				`${lazyLoadCfg.componentsDir}tinymce/tinymce.js${anticache}`,
				`${lazyLoadCfg.componentsDir}angular-ui-tinymce/src/tinymce.js${anticache}`,
				`${lazyLoadCfg.componentsDir}tinymce/themes/silver/theme.js${anticache}`,
			],
		});
		vm.showLoader = true;
		eventService.subscribeTo(
			'ocLazyLoad.moduleLoaded',
			(event, module) => {
				if (module === 'ui.tinymce') {
					vm.showLoader = false;
				}
			},
			$scope
		);
	}

	vm.$onInit = function () {
		vm.fullscreenContainer = $mdUtil.getClosest($element[0], (node) => {
			return (
				(node.classList && node.classList.contains('mx-wizard--page-content')) || (node.tagName && (node.tagName === 'MX-DIALOG-CONTAINER' || node.tagName === 'NG-FORM'))
			);
		});
		vm.textContainer = $element[0];
		vm.realParentContainer = $element[0].parentNode;

		/* tablet-landscape */
		isMobile = deviceService.screenMobile();

		useAdvancedMode = isMobile ? false : vm.advancedMode ? vm.advancedMode.toLowerCase() !== 'false' : true;

		const defalutHeight = useAdvancedMode ? 200 : 115;
		const heightInt = parseInt(vm.height, 10) || defalutHeight;
		vm._heightPx = heightInt + 'px';

		if (useAdvancedMode || isMobile) {
			fixedToolbarContainer = addId($element.find('.mx-rich-text-box--toolbar-top'));
		} else {
			fixedToolbarContainer = addId($element.find('.mx-tinymce-container'));
			isToolbarBottomMode = true;
			$element.addClass('mx-rich-text-box-toolbar-bottom-mode');
		}

		// Postpone a little bit so `vm._readOnly` and `vm._disabled` properties became initialized. Otherwise `vm.isActivated` always will be true.
		$scope.$evalAsync(() => {
			updateIsActivated();
		});

		vm.tinymceOptions = {
			fixed_toolbar_container: fixedToolbarContainer,
			inline: true,
			menubar: false,
			statusbar: false,
			contextmenu: false,
			toolbar_persist: true,
			toolbar_mode: 'floating',
			skin: 'tinymce-5',
			plugins: (useAdvancedMode ? ['link image media table advlist lists'] : 'link image media') + (vm.allowCodeEditor ? ' code' : ''),
			/* enables pasting images from clipboard */
			paste_data_images: !isMobile,
			/* prevents auto upload for images */
			automatic_uploads: false,
			browser_spellcheck: true,
			file_picker_types: 'image',
			// image picker that convert image to base64 and insert it to content
			file_picker_callback: function (cb) {
				var inputClass = 'mx-rich-text-box--input-upload';
				var input = document.getElementsByClassName(inputClass)[0];
				if (!input) {
					input = document.createElement('input');
					input.setAttribute('type', 'file');
					input.setAttribute('accept', 'image/*');
					input.style.display = 'none';
					input.className = inputClass;
					document.body.appendChild(input);
				}

				// `onchange` event should be redefined each time
				input.onchange = function () {
					var file = this.files[0];

					var classFilereader = new FileReader();
					classFilereader.onload = function (base64) {
						var imgData = base64.target.result;
						cb(imgData, { title: file.name });
					};

					classFilereader.readAsDataURL(file);
				};

				input.click();
			},

			toolbar:
				(useAdvancedMode
					? 'bold italic underline | fontsize forecolor backcolor removeformat | styles | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table link image media | fullscreen'
					: 'bold italic underline | bullist | link image media | fullscreen') + (vm.allowCodeEditor ? ' code' : ''),
			custom_colors: false,

			font_size_formats: '7pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 30pt 36pt 48pt 72pt',

			// Docs: https://www.tiny.cloud/docs/configure/url-handling/
			relative_urls: false,
			remove_script_host: false,
			convert_urls: true,
			cache_suffix: anticache,

			auto_focus: _defineBoolValue(vm.setFocus),

			setup: function (editor) {
				editor.settings = editor.settings || {};

				// Trick to fix cutting of dropdowns/dialogs in inline mode
				editor.on('PostRender', function () {
					setTimeout(function () {
						const uiContainer = document.querySelector('.tox.tox-tinymce-aux');
						if (uiContainer) {
							document.body.appendChild(uiContainer);
						}
					}, 1000);
				});

				editor.on('init', function () {
					editorInstance = editor;

					_handleDisabledMode(editor, vm._disabled);
					_handleReadonlyMode(editor, vm._readOnly);

					var defaultFont = (vm._options || {}).defaultFont || {};

					var tags = ' ,p,ul,ol,pre,table,blockquote'
						.split(',')
						.map(function (tag) {
							return '.mce-content-body ' + tag + ', .mx-rich-text-box-fake ' + tag;
						})
						.join(',');
					var fontStyles = `font-size: ${defaultFont.size || 'inherit'};
											font-family: ${defaultFont.family || 'inherit'};
											line-height: ${defaultFont.lineHeight || 'inherit'};`;

					var rteStylesId = 'rte-font-styles';
					if (!$('#' + rteStylesId).length) {
						var defaultStyles = `<style id="${rteStylesId}"> ${tags}{ margin: 0 0 ${isToolbarBottomMode ? '0' : '22px'} 0; ${fontStyles}}</style>`;
						$(this.getDoc().head).append(defaultStyles);
					}

					// All links should be opened in the new tab (Task:71035).
					this.parser.addAttributeFilter('src,href', function (nodes) {
						var i = nodes.length,
							node,
							attrName = 'target';
						while (i--) {
							node = nodes[i];
							var hrefAttr = node.attr('href');
							/** if link is local it should be openned on the same page. It is necessary for Table Of Content **/
							if (hrefAttr && hrefAttr[0] === '#') {
								continue;
							}
							node.attr(attrName, '_blank');
						}
					});

					this.parser.addAttributeFilter('allowfullscreen', function () {
						/** add parameter "media" to iframe with video for disabling sanitizing video on server **/
						$timeout(function () {
							var mediaSpans = editor.getElement().querySelectorAll('[data-mce-p-allowfullscreen]');
							mediaSpans.forEach(function (span) {
								span.setAttribute('data-mce-p-media', 'true');
							});
						});
					});

					const containerEl = $element.find('> md-input-container--mx-theme');
					editor.on('focus', function (e) {
						$element.find('.mx-rich-text-box--toolbar-top').show();

						$timeout(function () {
							vm.onFocus({ event: e, editor: editor });
						});
						containerEl.addClass('md-input-focused');
					});
					editor.on('blur', function (e) {
						$timeout(function () {
							vm.model = editor.getContent();
							vm.onBlur({ event: e, editor: editor });
						});
						containerEl.removeClass('md-input-focused');
					});

					mxTinymceUtils.extendMissingI18n(editor);

					vm.setHintHandlers($element.find('.mce-content-body'));
				});

				if (vm.fullscreenContainer) {
					editor.ui.registry.addButton('fullscreen', {
						tooltip: 'Fullscreen',
						shortcut: 'Ctrl+Shift+F',
						icon: 'fullscreen',
						onAction: function () {
							toggleFullscreen();
						},
					});
				}

				editor.on('keypress', function (event) {
					if (this.getBody().getAttribute('contenteditable') === 'false') {
						event.preventDefault();
					}
				});

				editor.on('keydown', function (event) {
					if (event.keyCode === 13) {
						setTimeout(() => fixCaretVisibility(editor));
					}
				});

				// This code fixes sizes for previously-wrongly-saved images, which caused whis bug https://matrix42.visualstudio.com/BPM/_workitems/edit/202195
				// Additional reason of this problem is that angular-$sanitazer remove `style` attribute for all tags including <img />
				// It will not effect new images.
				editor.on('ObjectResizeStart', function (e) {
					if (e.target.nodeName === 'IMG') {
						var jqEl = $(e.target);
						if (jqEl.attr('style')) {
							jqEl.css('height', '');
							jqEl.attr('data-mce-style', jqEl.attr('style'));
						}
					}
				});

				if (typeof vm.externalSetup === 'function') {
					vm.externalSetup(editor);
				}
			},
		};

		// Posibility to select images from pre-set list of images from server
		var mxLoadingCssClass = 'mx-loading-bg';
		if (vm.mxForm && vm.mxForm.objectId && vm.mxForm.entityName) {
			vm.tinymceOptions.image_list = function (success) {
				var loadingIndicatorContainer = $element.find('.mx-rich-text-box-real');
				loadingIndicatorContainer.addClass(mxLoadingCssClass);

				attachmentService.getFiles({ objectIds: vm.mxForm.objectId && [vm.mxForm.objectId] }).then(function (files) {
					var imgExtensions = /(\.jpg|\.jpeg|\.jpe|\.png|\.gif|\.bmp|\.tif|\.tiff)$/i;
					var attachedImgsArr = files
						.filter(function (file) {
							return imgExtensions.test(file.name);
						})
						.map(function (img) {
							return {
								title: img.name,
								value: http.formatUrl(`api/fileStorage/${img.id}`),
							};
						});
					success(attachedImgsArr);
					loadingIndicatorContainer.removeClass(mxLoadingCssClass);
				});
			};
		}

		angular.extend(vm.tinymceOptions, mxTinymceUtils.getMceI18nOptions());

		var originalSetupFn = vm.tinymceOptions.setup;
		var incommingSetup = vm._options && vm._options.setup;
		angular.extend(vm.tinymceOptions, vm._options || {});
		vm.tinymceOptions.setup = function (editor) {
			originalSetupFn(editor);
			if (incommingSetup) {
				incommingSetup(editor);
			}
		};

		Object.defineProperty(vm, '_ignoreReadonly', {
			get: function () {
				return !!vm.ignoreReadonly;
			},
		});

		mx.components.FormControlControllerBase.call(vm, $timeout);
	};

	$scope.$watch('vm._disabled', function (newValue) {
		_handleDisabledMode(editorInstance, newValue);
	});

	$scope.$watch('vm._readOnly', function (newValue) {
		_handleReadonlyMode(editorInstance, newValue);
	});

	vm.$onChanges = (changes) => {
		if (changes.isFullscreenModeEnabled) {
			toggleFullscreen(changes.isFullscreenModeEnabled.currentValue);
		}
	};

	$scope.$on('$destroy', () => {
		toggleFullscreen(false);
	});

	return vm;

	function fixCaretVisibility(editor) {
		const editorBody = $(editor.bodyElement);
		const editorBodyHeight = editorBody.height();
		const activeNode = $(editor.selection.getNode());
		const activeNodeTopShift = activeNode.position().top + activeNode.height();
		if (editorBodyHeight < activeNodeTopShift) {
			editorBody[0].scrollBy(0, activeNodeTopShift - editorBodyHeight + 10);
		}
	}

	function toggleFullscreen(isFullscreenParam) {
		if (vm.fullscreenContainer && (typeof isFullscreenParam === 'undefined' || (typeof isFullscreenParam === 'boolean' && isFullscreenParam !== isFullscreen))) {
			isFullscreen = !isFullscreen;
			if (isFullscreen) {
				vm.fullscreenContainer.appendChild(vm.textContainer);
				vm.textContainer.classList.add('fullscreen');
			} else {
				vm.realParentContainer.appendChild(vm.textContainer);
				vm.textContainer.classList.remove('fullscreen');
			}
			vm.onFullscreenToggle({ isFullscreenModeEnabled: isFullscreen, realParentContainer: vm.realParentContainer, fullscreenContainer: vm.fullscreenContainer });

			// refresh Toolbar, so overflowed buttons have correct possiton
			window.dispatchEvent(new Event('resize'));
		}
	}

	// used to properly position tinymce toolbar (in inline mode)
	function addId(el) {
		var id = Math.random() * 10e16;
		el.attr('data-editor-id', id);
		return '[data-editor-id="' + id + '"]';
	}

	function _defineBoolValue(value) {
		return typeof value === 'boolean' ? value : typeof value === 'string' ? value.toLowerCase() !== 'false' : !!value;
	}

	function updateIsActivated() {
		vm.isActivated = vm.isActivated || (!vm._disabled && !vm._readOnly) || vm._ignoreReadonly;
	}

	function _handleDisabledMode(editor, value) {
		var boolValue = _defineBoolValue(value && !vm._ignoreReadonly);
		if (editor) {
			editor.mode.set(boolValue ? 'readonly' : 'design');
			$($element).attr('disabled', boolValue);
		}
		updateIsActivated();
	}

	function _handleReadonlyMode(editor, value) {
		var boolValue = _defineBoolValue(value && !vm._ignoreReadonly);
		if (editor) {
			editor.mode.set(boolValue ? 'readonly' : 'design');
			$($element).attr('readonly', boolValue);
		}
		updateIsActivated();
	}
}
